import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	objectSearchErrorTitle: {
		id: 'proforma-panel-in-issue-view-ui.stores.object-search-error-title',
		defaultMessage: "We couldn't fetch any objects for this field",
		description:
			'Error title informing the user that there was an error while fetching CMDB objects in jira work item view',
	},
	objectSearchErrorDescription: {
		id: 'proforma-panel-in-issue-view-ui.stores.object-search-error-description',
		defaultMessage:
			'Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.',
		description:
			'Error message informing user the potential work items of failing CMDB object search in jira work item view',
	},
});
